import { render } from "./homeManagerMenu.vue?vue&type=template&id=5c39bc9a&scoped=true"
import script from "./homeManagerMenu.vue?vue&type=script&lang=js"
export * from "./homeManagerMenu.vue?vue&type=script&lang=js"

import "./homeManagerMenu.vue?vue&type=style&index=0&id=5c39bc9a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c39bc9a"]])

export default __exports__